import { ApiError } from '@gorila-shared-ui/components';
import { fetchUserAttributes, getCurrentUser, signIn, signOut } from 'aws-amplify/auth';

export const authSignIn = async (username: string, password: string): Promise<{ user?: any; error?: ApiError }> => {
  try {
    const user = await signIn({ username, password });
    return { user };
  } catch (error) {
    return {
      error: 'Credenciales incorrectas.',
    };
  }
};

export const autoLogin = async (): Promise<{ user?: any; error?: ApiError }> => {
  try {
    const { username } = await getCurrentUser();
    const userAttributes = await fetchUserAttributes();
    if (!userAttributes['custom:granted_projects'] || userAttributes['custom:granted_projects'].includes('gnp_kmseguros') === false) {
      return { error: 'Usuario sin permisos' };
    }
    return { user: { username, attributes: userAttributes } };
  } catch (err) {
    return { error: 'Not authenticated' };
  }
};

export const authSignOut = async (): Promise<void> => {
  await signOut();
};
